const FORM_KEY = {
  DEFAULT: 'default',
  SZ: 'sz',
  SK_STORE: 'skstore',
  XBET: '1xbet',
  BET_CITY: 'betCity',
  FONBET: 'fonbet',
};

const FORM_ID: { [key: string]: string } = {
  '1': FORM_KEY.SZ,
  '2': FORM_KEY.SK_STORE,
  '3': FORM_KEY.XBET,
  '4': FORM_KEY.BET_CITY,
  '5': FORM_KEY.FONBET,
};

export { FORM_ID, FORM_KEY };
